import type { NormalizedAuthData } from '../auth/normalizedAuthData.ts'

export class UserProfileData {
  name: string
  surname: string
  email: string
  initials: string
  profilePicture: string
  displayName: string
  idToken: string
  refreshToken: string
  expiresIn: string
  authProvider: string

  constructor(authData: NormalizedAuthData, provider: string) {
    this.displayName = authData.displayName || ''
    const [name, surname] = authData.displayName?.split(' ') || ['', '']
    this.name = name
    this.surname = surname
    this.email = authData.email
    this.initials = (name?.[0] ?? '').toUpperCase() + (surname?.[0] ?? '').toUpperCase()
    this.profilePicture = authData.profilePicture || ''
    this.idToken = authData.idToken
    this.refreshToken = authData.refreshToken || ''
    this.expiresIn = authData.expiresIn
    this.authProvider = provider
  }
}
